// extracted by mini-css-extract-plugin
export default {"price":"_6-z","priceRow":"a7-z","onSale":"b7-z","msrpLabelPrice":"c7-z","msrpLabel":"d7-z","originalPrice":"e7-z","percentOff":"f7-z"};